export default __webpack_public_path__ + "static/media/fatimaNcake.80d1a3f2.jpeg";